import logo from "@/assets/dr-vahe-logo.png";
import ClinicNAP from "./ClinicNAP";
import { trackEvent } from "@/lib/analytics";

const Navbar = () => {
  return (
    <header className="sticky top-0 z-50 bg-background/85 backdrop-blur-md border-b border-border/40">
      <div className="hidden md:flex justify-end items-center gap-6 max-w-7xl mx-auto px-6 md:px-10 pt-2">
        <ClinicNAP variant="compact" />
      </div>
      <nav className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3">
          <img src={logo} alt="Dr Vahe Clinic" className="h-10 w-10 object-contain" />
          <span className="font-display text-lg tracking-[0.25em] uppercase text-foreground hidden sm:block">
            Dr Vahe <span className="text-accent">Clinic</span>
          </span>
        </a>
        <div className="hidden md:flex items-center gap-10 text-[11px] tracking-[0.25em] uppercase font-medium">
          <a href="#offer" className="hover:text-accent transition-colors">The Offer</a>
          <a href="#approach" className="hover:text-accent transition-colors">Approach</a>
          <a href="#results" className="hover:text-accent transition-colors">Results</a>
          <a href="/blepharoplasty-recovery-guide" className="hover:text-accent transition-colors">Recovery</a>
          <a href="#faq" className="hover:text-accent transition-colors">FAQ</a>
        </div>
        <a
          href="#booking"
          onClick={() => trackEvent("cta_book_click", { location: "navbar", label: "Enquire" })}
          className="px-7 py-3 bg-primary text-primary-foreground text-[10px] uppercase tracking-[0.3em] hover:bg-accent transition-colors duration-500 rounded-full"
        >
          Enquire
        </a>
      </nav>
    </header>
  );
};

export default Navbar;
